/**
 * 計測イベントの単一の入口
 *
 * - GA4: gtag.js へ直接送信する（測定 ID 必須）
 * - GTM: dataLayer へミラーする（測定 ID には非依存）
 *
 * 責務分担: GA4 / X Pixel はコード直設置、広告のコンバージョンタグは GTM 管理画面側で運用する。
 * GTM コンテナに GA4 設定タグを置くと page_view が二重計上されるため、そちらには置かない。
 */

import { isTrackingRejected } from "./consent";
import { pushToDataLayer } from "./gtm";

export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID ?? "";

// gtag.js の型定義
declare global {
  interface Window {
    gtag: (
      command: string,
      targetOrAction: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

function isGtagAvailable(): boolean {
  return (
    typeof window !== "undefined" && typeof window.gtag === "function"
  );
}

/**
 * GA4 専用のページビュー送信。
 * GTM 側の遷移計測は AnalyticsProvider が spa_page_view を push して担うため、
 * ここでミラーすると二重計上になる。
 */
export function pageview(url: string): void {
  // 拒否済みチェック: GA4 は ga-disable フラグでも止まるが、送信入口でも弾く（多層防御）
  if (isTrackingRejected()) return;
  if (!GA_MEASUREMENT_ID || !isGtagAvailable()) return;
  window.gtag("config", GA_MEASUREMENT_ID, { page_path: url });
}

export function event(
  action: string,
  params?: Record<string, unknown>
): void {
  // 拒否済みチェック: 拒否した瞬間のページでは読み込み済みの GTM / X Pixel が
  // 次回ページ読み込みまで生き続けるため、送信側で止めないとコンバージョン
  // イベントが拒否後も広告タグへ流れる（スクリプト読み込み制御では防げない）
  if (isTrackingRejected()) return;
  // GA4 送信と dataLayer ミラーは独立した条件で判定する。
  // 早期 return にまとめると、GA4 測定 ID 未設定の環境（ステージング等）で
  // ミラーまで止まる（X Pixel 導入時に踏んだ結合事故と同型）。
  if (GA_MEASUREMENT_ID && isGtagAvailable()) {
    window.gtag("event", action, params);
  }
  pushToDataLayer(action, params);
}
